
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic01 as ObiHydraulic01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-01.js';
 
 
 

 
 export const ObiHydraulic01 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-01',
   elementClass: ObiHydraulic01Element,
   events: {
     
   }
  });
 
 